<template>
  <div>
    <!-- Pass toggleSidebar as a prop to NavbarTopMap -->
    <div class="listingpush" />
    <section
      data-v-eca9674e=""
      class="cat_product_area"
    >
      <div class="chat-container">
        <!--  <button class="panel-button" @click="toggleSidebar"> Open conversation</button> -->

        <!-- Sol sidebar -->
        <div
          v-show="showSidebarElement"
          class="chat-sidebar animate__animated"
          :class="{ animate__backInLeft: showSidebar, animate__backOutLeft: !showSidebar }"
          @animationend="handleAnimationEnd"
        >
          <div class="chat-sidebar-header">
            <h3>Messages</h3>
          </div>
          <div class="chat-search-bar">
            <input
              type="text"
              placeholder="Search..."
            >
          </div>
          <div
            v-if="error"
            class="error-state"
          >
            {{ error }}
          </div>
          <ul
            v-else
            class="chat-contact-list"
          >
            <div
              v-if="loading"
              class="loading-state"
            >
              <i class="fas fa-spinner fa-spin" />
              Mesajlar yükleniyor...
            </div>
            <template v-else>
              <li
                v-for="conv in conversations"
                :key="conv.id"
                class="chat-contact-item"
                :class="{ active: activeConversation?.id === conv.id, 'has-unread': conv.hasUnread }"
                @click="selectConversation(conv)"
              >
                <img
                  :src="conv.coverImage || 'https://placehold.co/50x50/ced4da/6c757d'"
                  :alt="conv.adTitle"
                  class="conversation-image"
                >
                <div class="chat-contact-info">
                  <div class="chat-contact-name">
                    {{ truncateTitle(conv.adTitle) }}
                  </div>
                  <div class="chat-contact-message">
                    {{ truncateTitle(conv.lastMessage, 30) }}
                  </div>
                  <div class="chat-contact-message">
                    {{ formatConvTime(conv.lastMessageTime?.toDate() ?? new Date()) }}
                  </div>
                </div>
              </li>
            </template>
          </ul>
        </div>

        <!-- Sağ chat alanı -->
        <div
          v-if="activeConversation"
          class="chat-area"
        >
          <div class="chat-header">
            <img
              :src="activeConversation.coverImage || 'https://placehold.co/60x60/6c757d/343a40'"
              :alt="activeConversation.adTitle"
              class="chat-header-image"
            >
            <img
              :src="chatPartnerAvatar"
              alt=""
            >
            <div class="chat-header-info">
              <h4>{{ truncateTitle(activeConversation.adTitle, 30) }}</h4>
              <p>Now Chatting with {{ chatPartnerName }} - {{ chatPartnerEmail }}</p>
            </div>
          </div>

          <!-- Mesajlar bölümü -->
          <div
            ref="messagesContainer"
            class="chat-messages"
          >
            <div
              v-if="messagesLoading"
              class="loading-state"
            >
              <i class="fas fa-spinner fa-spin" />
              Mesajlar yükleniyor...
            </div>
            <div
              v-else-if="messagesError"
              class="error-state"
            >
              {{ messagesError }}
            </div>
            <template v-else>
              <div
                v-for="(message, index) in messages"
                :key="message.id"
                class="chat-message"
                :class="{
                  sent: isOwnMessage(message.senderId),
                  'animate__animated animate__heartBeat': index === messages.length - 1,
                }"
              >
                <div
                  class="chat-message-content"
                  :class="{ sent: isOwnMessage(message.senderId) }"
                >
                  {{ message.message }}
                  <div class="chat-message-time">
                    {{ formatMessageTime(message.createdAt) }}
                  </div>
                </div>
              </div>
            </template>
          </div>

          <!-- Mesaj gönderme alanı -->
          <div class="chat-input-area">
            <input
              ref="chatInput"
              v-model="newMessage"
              type="text"
              class="chat-input"
              placeholder="Mesajınızı yazın..."
              :disabled="isPending"
              @keydown="handleKeyDown"
            >
            <button
              class="chat-send-button"
              :disabled="isPending || !newMessage.trim()"
              @click="handleSendMessage"
            >
              <i class="fas fa-paper-plane" />
            </button>
          </div>

          <!-- Hata mesajı gösterimi -->
          <div
            v-if="sendError"
            class="error-toast"
          >
            {{ sendError }}
          </div>
        </div>

        <!-- Aktif konuşma yoksa gösterilecek alan -->
        <div
          v-else
          class="chat-area chat-area-empty"
        >
          <div class="empty-state">
            <i class="fas fa-comments" />
            <p>Select a conversation</p>
          </div>
        </div>
      </div>
    </section>
    <div class="listingpush" />
  <!-- Bottom Navbar -->
  </div>
</template>

<script setup>
  /* eslint-disable */
  import { ref, onMounted, onUnmounted, watch, nextTick, computed } from 'vue';
  import { useConversations } from '../composables/useConversations';
  import { useMessages } from '../composables/useMessages';
  import { getAuth } from 'firebase/auth';
  import { useSendMessage } from '../composables/sendMessage';
  import { useChatStore } from '@/stores/chatStore';
  import { storeToRefs } from 'pinia';
  import NavbarTop from '@/components/NavbarTop.vue'; // Adjust the import path
  import { useUnreadMessages } from '@/composables/useUnreadMessages';

  import LoadingSpinner from '../components/LoadingSpinner.vue';

  // Add this to track browser width
  const browserWidth = ref(window.innerWidth);

  // Function to update browser width
  const updateBrowserWidth = () => {
    browserWidth.value = window.innerWidth;
  };

  // Add resize event listener on component mount
  onMounted(() => {
    window.addEventListener('resize', updateBrowserWidth);
  });

  // Remove resize event listener on component unmount
  onUnmounted(() => {
    window.removeEventListener('resize', updateBrowserWidth);
  });

  const chatStore = useChatStore();
  const { showSidebar, showSidebarElement } = storeToRefs(chatStore);

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const {
    messages,
    loading: messagesLoading,
    error: messagesError,
    listenToMessages,
    markMessagesAsRead,
    markAllMessagesAsRead,
  } = useMessages();
  const auth = getAuth();

  let unsubscribeConversations = null;
  let unsubscribeMessages = null;

  // Sidebar toggle fonksiyonunu güncelleyelim
  const toggleSidebar = () => {
    console.log('Toggle sidebar');
    if (showSidebar.value) {
      // Sidebar'ı kapatırken
      showSidebar.value = false;
      // Element hala görünür kalacak, animasyon bitince kaldırılacak
      console.log('False:', showSidebarElement.value);
    } else {
      // Sidebar'ı açarken
      showSidebarElement.value = true;
      showSidebar.value = true;
      console.log('True:', showSidebarElement.value);
    }
  };

  watch(
    browserWidth,
    (newWidth) => {
      if (newWidth >= 992) {
        showSidebar.value = true;
        showSidebarElement.value = true;
      }
    },
    { immediate: true },
  ); // immediate: true ile sayfa yüklendiğinde hemen çalışır

  // Animasyon bitişini dinleyelim
  const handleAnimationEnd = (event) => {
    if (!showSidebar.value) {
      showSidebarElement.value = false;
    }
  };

  // Aktif konuşma
  const activeConversation = ref(null);
  const { conversations, error, loading, listenToConversations } =
    useConversations(activeConversation);

  // Mesaj inputu için ref
  const newMessage = ref('');

  // messagesContainer ref'i
  const messagesContainer = ref(null);

  // Input için ref ekle
  const chatInput = ref(null);
  // Script kısmına ekleyelim
  const chatPartnerName = computed(() => {
    if (!activeConversation.value) return '';

    return auth.currentUser.uid === activeConversation.value.sender.id
      ? activeConversation.value.receiver.name
      : activeConversation.value.sender.name;
  });

  const chatPartnerAvatar = computed(() => {
    if (!activeConversation.value) return '';

    return auth.currentUser.uid === activeConversation.value.sender.id
      ? activeConversation.value.receiver.photoURL
      : activeConversation.value.sender.photoURL;
  });

  const chatPartnerEmail = computed(() => {
    if (!activeConversation.value) return '';

    return auth.currentUser.uid === activeConversation.value.sender.id
      ? activeConversation.value.receiver.email
      : activeConversation.value.sender.email;
  });

  // İlan başlığını kısaltma fonksiyonu
  const truncateTitle = (title, maxLength = 15) => {
    return title?.length > maxLength ? title.slice(0, maxLength) + '...' : title;
  };

  // Yeni mesaj geldiğinde
  const handleNewMessage = async (type, newMessage) => {
    if (type === 'initial') {
      await nextTick();
      await delay(200);
      scrollGoToBottom();
    } else if (type === 'new') {
      if (
        newMessage &&
        newMessage.senderId !== auth.currentUser?.uid &&
        newMessage.isRead === false
      ) {
        const conversationToUpdate = conversations.value?.find(
          (conv) => conv.id === newMessage.conversationId,
        );

        if (conversationToUpdate) {
          if (activeConversation.value?.id === conversationToUpdate.id) {
            // Önce okundu olarak işaretle
            await markAllMessagesAsRead(conversationToUpdate.id);

            // Sonra yanıp sönme efekti
            conversationToUpdate.hasUnread = false; // Başlangıçta false

            await delay(100);
            conversationToUpdate.hasUnread = true; // Kısa süre true

            await delay(100);
            conversationToUpdate.hasUnread = false; // Tekrar false
          } else {
            // Aktif olmayan konuşmalarda kalıcı kırmızı
            conversationToUpdate.hasUnread = true;
          }
        }
      }
      await nextTick();
      await delay(200);
      scrollGoToBottom();
    }
  };

  const loadingAllChatMessages = ref(true);

  // Konuşma listesine tıklama
  const selectConversation = async (conversation) => {
    if (activeConversation.value?.id === conversation.id) return;

    loadingAllChatMessages.value = true; // Yükleme başladı

    if (conversation.hasUnread) {
      await markAllMessagesAsRead(conversation.id);
      conversation.hasUnread = false;
    }

    activeConversation.value = conversation;

    if (unsubscribeMessages) {
      unsubscribeMessages();
    }

    // DOM'un güncellenmesi için bekle
    await nextTick();
    await delay(100);

    // Yükleme tamamlandı
    loadingAllChatMessages.value = false;

    // Dinlemeyi başlat
    if (!loadingAllChatMessages.value) {
      unsubscribeMessages = listenToMessages(conversation.id, handleNewMessage);
    }

    scrollGoToBottom();
    // Only toggle sidebar if browser width is less than 540px
    if (browserWidth.value < 992) {
      toggleSidebar();
    }
  };
  // Mesaj zaman formatı
  const formatMessageTime = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate();
    return date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
  };
  const formatConvTime = (date) => {
    if (!(date instanceof Date)) {
      console.error('Invalid date:', date);
      return '';
    }
    return date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
  };
  // Mesaj sahibini kontrol et
  const isOwnMessage = (senderId) => {
    return senderId === auth.currentUser?.uid;
  };

  const { sendMessage, error: sendError, isPending } = useSendMessage();

  // scrollGoToBottom fonksiyonu
  const scrollGoToBottom = () => {
    if (messagesContainer.value) {
      messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight;
    }
  };

  const handleSendMessage = async () => {
    if (!newMessage.value.trim() || !activeConversation.value) return;

    const messageData = {
      conversationId: activeConversation.value.id, // Bunu ekleyelim
      adId: activeConversation.value.adId,
      adTitle: activeConversation.value.adTitle,
      coverImage: activeConversation.value.coverImage || '',
      senderId: auth.currentUser.uid,
      senderEmail: auth.currentUser.email,
      senderPhotoURL: auth.currentUser.photoURL,
      receiverId: activeConversation.value.participants.find((id) => id !== auth.currentUser.uid),
      message: newMessage.value.trim(),
    };

    try {
      const success = await sendMessage(messageData);

      if (success) {
        newMessage.value = '';
        await nextTick();
        await delay(200);
        await scrollGoToBottom();
        chatInput.value?.focus();
      } else {
        console.error('Mesaj gönderilemedi');
      }
    } catch (error) {
      console.error('Mesaj gönderme hatası:', error);
    }
  };

  // Enter tuşu ile mesaj gönderme
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSendMessage();
    }
  };

  // WatchEffect yerine watch kullanabiliriz
  watch(
    () => activeConversation.value?.id,
    (newId, oldId) => {
      if (unsubscribeMessages) {
        unsubscribeMessages();
      }
      if (newId) {
        unsubscribeMessages = listenToMessages(newId, handleNewMessage);
      }
    },
    { immediate: true },
  );

  onMounted(() => {
    unsubscribeConversations = listenToConversations();
  });

  onUnmounted(() => {
    if (unsubscribeMessages) {
      unsubscribeMessages();
    }
    if (unsubscribeConversations) {
      unsubscribeConversations();
    }
  });
</script>

<style scoped>
  .panel-button {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: fixed;
    rotate: -90deg;
    background-color: #6c757d;
    color: white;
    border-radius: 10px 10px 0 0;
    border: none;
    padding: 10px 20px;
    left: -40px;
    /* Sol tarafa kaydırma */
    top: 30%;
    /* Sayfanın ortasına hizalama */
    transform: translateY(-50%);
    /* Dikey ortalama */
    transform-origin: right center;
    /* Döndürme merkezi */
    z-index: 100;
    /* Üstte görünmesi için */
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    /* Gölge efekti */
    transition: left 0.3s ease;
    /* Animasyon */
  }

  .chat-container {
    margin: 90px auto 80px;
    width: 80%;
    max-width: 1200px;
    background-color: #fff;
    border-radius: 15px;
    overflow: hidden;
    display: flex;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
    height: calc(100vh - 90px);
    /* 90px navbar için */
  }
  .chat-container {
    width: 100%;
  }

  .chat-sidebar {
    background-color: rgba(248, 249, 250, 0.75);
    /* f8f9fa renk kodu, 0.75 opaklık */
    backdrop-filter: blur(8px);
    /* Arka planı bulanıklaştır */
    -webkit-backdrop-filter: blur(8px);
    /* Safari için destek */
    width: 35%;
    border-right: 1px solid #e9ecef;
    padding: 25px 5px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    animation-duration: 0.8s;
    animation-fill-mode: forwards;
    /* Animasyon son durumunda kalsın */
    z-index: 1;
  }
  /* Mobil görünüm için media query */
  @media screen and (max-width: 492px) {
  }
  @media screen and (max-width: 992px) {
    .listingpush {
      min-height: 75px;
    }
    .chat-container:has(.chat-sidebar) .chat-area {
      width: 100%;
    }
    .chat-container {
      width: 100%;
      position: absolute;
      border-radius: 0;
      height: 100%;
      margin: 0;
      bottom: 60px;
      padding-top: 40px;
    }
    .chat-header {
      padding-bottom: 5px !important;
      padding-top: 15px;
    }
    .chat-header-info h4 {
      font-size: 0.8rem !important;
    }
    .chat-input-area {
      padding-top: 5px !important;
    }
    .chat-sidebar {
      background-color: rgba(248, 249, 250, 0.75);
      /* f8f9fa renk kodu, 0.75 opaklık */
      backdrop-filter: blur(8px);
      /* Arka planı bulanıklaştır */
      -webkit-backdrop-filter: blur(8px);
      /* Safari için destek */
      width: 35%;
      border-right: 1px solid #e9ecef;
      padding: 25px;
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow-y: auto;
      position: absolute;
      width: 100%;
      animation-duration: 0.8s;
      animation-fill-mode: forwards;
      /* Animasyon son durumunda kalsın */
    }
    .panel-button {
      display: none;
      /* Mobilde panel butonunu gizle */
    }
    /* Sidebar açıkken chat-area'yı daraltmak için yeni kural */
    /* Safari için fallback (has selector desteklemeyenler için) */
    .chat-sidebar + .chat-area {
      width: 100%;
    }
  }

  @media (min-width: 992px) {
    .listingpush {
      min-height: 75px;
    }
    .chat-container {
      margin: 90px auto 80px;
      width: 80%;
      max-width: 1200px;
      background-color: #fff;
      border-radius: 15px;
      overflow: hidden;
      display: flex;
      box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
      height: calc(100vh - 90px);
      position: absolute;
      bottom: 0;
      top: 0;
      left: 0;
      right: 0;
    }
  }

  @media (min-width: 1200px) {
    .listingpush {
      min-height: 75px;
    }
  }

  .chat-sidebar-header {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .chat-sidebar-header h3 {
    margin: 0;
    font-size: 1.5rem;
    color: #343a40;
  }

  .chat-search-bar {
    background-color: #fff;
    border-radius: 25px;
    padding: 10px 15px;
    margin-bottom: 25px;
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
  }

  .chat-search-bar input[type='text'] {
    border: none;
    outline: none;
    width: 100%;
    margin-left: 10px;
    font-size: 1rem;
    color: #495057;
  }

  .chat-contact-list {
    list-style: none;
    padding: 0;
    margin: 0;
    overflow-y: auto;
    /* Scrollbar eklenirse */
  }

  .chat-contact-list li:last-child {
    border-bottom: 1px solid rgb(183 183 183 / 19%);
  }
  .chat-contact-item {
    display: flex;
    align-items: center;
    padding: 12px 15px;
    cursor: pointer;
    transition: background-color 0.2s;
    border: 1px solid rgb(183 183 183 / 19%);
    border-bottom: none;
  }

  .chat-contact-item:hover,
  .chat-contact-item.active {
    background-color: #e0e0e0;
  }

  .chat-contact-item.active {
    background-color: #dee2e6;
  }

  .chat-contact-item img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 15px;
    object-fit: cover;
  }

  .chat-contact-info {
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: stretch;
    justify-content: space-between;
    align-items: center;
  }

  .chat-contact-name {
    font-weight: bold;
    color: #343a40;
    margin-bottom: 5px;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .chat-contact-message {
    color: #6c757d;
    font-size: 0.9rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 180px;
  }

  .chat-contact-badge {
    background-color: #fd7e14;
    color: white;
    border-radius: 50%;
    padding: 6px 10px;
    font-size: 0.8rem;
    margin-left: 5px;
  }

  .chat-contact-item.has-unread {
    position: relative;
    background-color: rgba(220, 53, 69, 0.1);
    /* Hafif kırmızı arka plan */
  }

  .chat-contact-item.has-unread::after {
    content: '';
    position: absolute;
    right: 10px;
    top: 10px;
    width: 10px;
    height: 10px;
    background-color: #dc3545;
    border-radius: 50%;
    box-shadow: 0 0 0 2px #fff;
  }

  .chat-contact-item.active.has-unread {
    border: 2px solid #dc3545;
    background-color: rgba(220, 53, 69, 0.15);
  }

  .chat-area {
    width: 100%;
    /* 65% yerine 100% yapıyoruz */
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  .chat-header {
    display: flex;
    align-items: center;
    padding-bottom: 25px;
    border-bottom: 1px solid #e9ecef;
  }

  .chat-header img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 20px;
    object-fit: cover;
  }
  .chat-header img:last-of-type {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-left: -40px;
    object-fit: cover;
  }
  .chat-header-info h4 {
    margin: 0;
    color: #343a40;
    font-size: 1.3rem;
  }

  .chat-header-info p {
    margin: 0;
    color: #6c757d;
    font-size: 0.9rem;
  }

  .chat-header-actions {
    margin-left: auto;
  }

  .chat-header-actions button {
    background: none;
    border: none;
    color: #6c757d;
    font-size: 1.2rem;
    margin-left: 15px;
    cursor: pointer;
    outline: none;
  }

  .chat-messages {
    flex-grow: 1;
    overflow-y: auto;
    padding: 25px 0;
    display: flex;
    flex-direction: column;
    gap: 15px;
    /* Mesajlar arası boşluk */
    height: calc(100% - 160px);
    /* Header ve input alanı için alan bırak */
    scroll-behavior: smooth;
    /* Yumuşak scroll */
  }

  .chat-message {
    display: flex;
    flex-direction: column;
    max-width: 75%;
    width: fit-content;
    /* Mesaj içeriğine göre genişlik */
    align-self: flex-start;
    /* Varsayılan olarak sola hizala */
  }

  .chat-message.sent {
    align-self: flex-end !important;
    /* Sağa hizalama için !important ekledik */
  }

  .chat-message-content {
    display: flex;
    background-color: #f7ecf0;
    color: #343a40;
    padding: 12px 10px 2px 20px;
    border-radius: 20px 20px 20px 5px;
    width: fit-content;
    /* İçeriğe göre genişlik */
    word-wrap: break-word;
    font-size: 1rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  .chat-message-content.sent {
    background-color: #74c6a3;
    color: #fff;
    border-radius: 20px 20px 5px 20px;
    margin-left: auto;
    /* Sağa hizalama için */
  }

  .chat-message-time {
    font-size: 0.85rem;
    color: rgb(108 117 125 / 46%);
    margin-top: 12px;
    align-self: flex-end;
    /* Zaman damgası her zaman sola */
  }

  .chat-message.sent .chat-message-time {
    align-self: flex-end;
    /* Gönderilen mesajlarda zaman damgası sağa */
  }

  .chat-input-area {
    padding-top: 25px;
    border-top: 1px solid #e9ecef;
    display: flex;
    align-items: center;
  }

  .chat-input {
    flex-grow: 1;
    border-radius: 25px;
    padding: 12px 18px;
    border: 1px solid #ced4da;
    margin-right: 15px;
    font-size: 1rem;
    outline: none;
  }

  .chat-send-button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 12px 18px;
    border-radius: 50%;
    cursor: pointer;
    outline: none;
    font-size: 1.1rem;
  }

  .chat-send-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  .chat-input:disabled {
    background-color: #f8f9fa;
    cursor: not-allowed;
  }

  .chat-area-empty {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .empty-state {
    text-align: center;
    color: #6c757d;
  }

  .empty-state i {
    font-size: 4rem;
    margin-bottom: 1rem;
  }

  .loading-state {
    text-align: center;
    padding: 20px;
    color: #6c757d;
  }

  .loading-state i {
    margin-right: 8px;
  }

  .error-state {
    text-align: center;
    padding: 20px;
    color: #dc3545;
    background-color: #f8d7da;
    border-radius: 8px;
    margin: 10px 0;
  }

  .error-toast {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: #f8d7da;
    color: #dc3545;
    padding: 12px 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
  }
</style>
